import { PrivilegeEnum as r } from "@hprofits/shared/auth";
import { ocPrivate as e } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as t } from "../swagger/tags.js";
import { ArbitrageModelRuleListQuerySchema as o, ArbitrageModelRuleListSchema as a } from "./schemas.js";
const d = {
  arbitrageModelRule: {
    findAll: e([r.ReadAdmin]).route({
      method: "GET",
      path: "/arbitrage-model-rules",
      summary: "List arbitrage model rules",
      tags: [t.ARBITRAGE_MODEL_RULES.name]
    }).input(o).output(a).errors({})
  }
};
export {
  d as arbitrageModelRuleContract
};
//# sourceMappingURL=contract.js.map
